export function parseUrl (urlToParse) {
  if (typeof window !== 'undefined') {
    let parser = document.createElement('a')
    parser.href = urlToParse
    return parser
  } else {
    var url = require('url')
    return new url.URL(urlToParse)
  }
}
